<div class="modal-header">
  @if (isNewMetaData) {
    <h4 class="modal-title h5" translate>New metadata key/value</h4>
  }
  @if (!isNewMetaData) {
    <h4 class="modal-title h5" translate>Edit metadata</h4>
  }
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form (ngSubmit)="onSave()" [formGroup]="metadataForm">
  <div class="modal-body">

    <!-- METADATA KEY -->
    <div class="form-row">

      <div class="col-12">
        <div class="form-group">
          <label for="type" translate>Metadata key</label>
          <scitis-required-field-indicator></scitis-required-field-indicator>
          <input
              (blur)="onKeyChanged()"
              [ngClass]="{ 'is-invalid': f.key.errors }"
              class="form-control"
              formControlName="key"
              id="key"
              name="key"
              type="text">
          @if (f.key.errors) {
            <div class="invalid-feedback">
              @if (f.key.errors.required) {
                <span translate>Key name required</span>
              }

              @if (f.key.errors.used) {
                <span translate>The key is already used!</span>
              }

              @if (f.key.errors.pattern) {
                <span translate>The key can only consist of latin letters, numbers, underscores.</span>
              }
            </div>
          }
        </div>
      </div>
    </div>

    <!-- METADATA VALUE -->
    <div class="form-row">

      <div class="col-12">
        <div class="form-group">
          <label for="type" translate>Metadata value</label>
          <input [ngClass]="{ 'is-invalid': f.value.errors }"
                 class="form-control"
                 formControlName="value"
                 id="value"
                 name="value"
                 type="text">
<!--          @if (f.value.errors) {-->
<!--            <div class="invalid-feedback">-->
<!--              @if (f.value.errors.required) {-->
<!--                <span translate>Metadata value required</span>-->
<!--              }-->
<!--            </div>-->
<!--          }-->
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-footer-inner">
      <div class="row align-items-center flex-fill">
        <div class="col">
          <scitis-required-field-indicator-explanation></scitis-required-field-indicator-explanation>
        </div>
        <div class="col-auto">
          <button (click)="onCancel()" class="btn btn-outline-primary mr-2" type="button">
            <span translate>Cancel</span>
          </button>
          <button [disabled]="isDisabledSaveBtn" class="btn btn-primary"
                  type="submit">
            <span translate>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>